import React from 'react';
import { useRouter } from 'next/router';
import { useIntl } from 'react-intl';
import { NavTabs } from '@fuww/library/src/Tabs';
import Tab from '../Tab';
import messages from '../../lib/messages.json';

const Tabs = () => {
  const { query, route: currentRoute } = useRouter();
  const marketId = Number(query.marketId);
  const standId = Number(query.standId);
  const intl = useIntl();

  return (
    <NavTabs
      value={currentRoute}
      NavTab={Tab}
      tabs={[
        {
          route: 'stand',
          params: { marketId, standId },
          value: '/stand',
          label: intl.formatMessage(messages.home),
        },
        {
          route: 'products',
          params: { marketId, standId },
          value: '/products',
          label: intl.formatMessage(messages.products),
        },
      ]}
    />
  );
};

export default Tabs;
